import React from 'react';

import classNames from 'classnames';

import IconBtn from '../../../modules/icon-btn/icon-btn';
import TableFooterWrapper from '../../../modules/table-footer-wrapper/table-footer-wrapper';
import { ORDER_DETAILED_STATUS } from '../../../types';
import currencyFormat from '../../../utils/currencyFormat';
import getWordDecl from '../../../utils/getWordDecl';
import UcpIcon from '../../order-detailed/order-detailed-action/ucp-btn.svg';

interface OrderRealizationsFooterProps {
  status: ORDER_DETAILED_STATUS;
  sum: number;
  onSubmit?: () => void;
  isInitiator: boolean;
  showAction: boolean;
  isError?: boolean;
  errorText?: string;
  positionsCount: number;
}

enum OrderRealizationsFooterStrings {
  INITIATOR_BTN = 'Создать решение о выпуске гибридного токена',
  RECIPIENT_BTN = 'Согласовать отгрузку',
}

const OrderRealizationsFooter: React.FC<OrderRealizationsFooterProps> = ({
  showAction,
  isInitiator,
  onSubmit,
  sum,
  positionsCount,
  isError,
  errorText,
}) => {
  const getDescString = () => {
    if (isError) {
      return <div className="table-footer__notice">{errorText}</div>;
    }

    return <span>{`Выбрано: ${positionsCount} на сумму:`}</span>;
  };

  const getErrorDesc = () => (
    <div className="table-footer__desc">
      {`${positionsCount} ${getWordDecl(positionsCount, [
        'позиция',
        'позиции',
        'позиций',
      ])} на сумму:`}
    </div>
  );

  return (
    <TableFooterWrapper
      blank={!showAction}
      right={
        <div
          className={classNames({
            'table-footer__realization': showAction,
          })}
        >
          {showAction && (
            <>
              {getDescString()}
              {isError && <div className="table-footer__notice-divider">|</div>}
              {isError && <span>{getErrorDesc()}</span>}
              <div className="table-footer__sum">
                {currencyFormat(sum, false)}
                <span> ₽</span>
              </div>
              <div>
                <IconBtn
                  onClick={() => {
                    if (onSubmit) {
                      onSubmit();
                    }
                  }}
                  disabled={isError}
                  sm
                  title={
                    isInitiator
                      ? OrderRealizationsFooterStrings.INITIATOR_BTN
                      : OrderRealizationsFooterStrings.RECIPIENT_BTN
                  }
                  icon={UcpIcon}
                />
              </div>
            </>
          )}
        </div>
      }
    />
  );
};

export default OrderRealizationsFooter;
